import { useState, useRef, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Paginator } from 'primereact/paginator';
import SaldoClienteList from './SaldoClienteList';
import SaldoClienteCadastrar from './SaldoClienteCadastrar';
import { HeaderTitle } from '../../components/HeaderTitle';
import { Card } from 'primereact/card';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import Container from '../../components/menu/Container';
import getSaldoCliente from '../../service/getSaldoCliente';
import postSaldoClienteCompra from '../../service/postSaldoClienteCompra';
import findSaldoClienteMovimentoService from '../../service/findSaldoClienteMovimento';
import { SortOrder } from 'primereact/api';
import getClienteService from '../../service/getCliente';

export default function SaldoClientePage() {
  const { state } = useGlobalState();
  const toast = useRef<Toast>(null);
  
  const [showForm, setShowForm] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [saldo, setSaldo] = useState(0.0);
  const [cliente, setCliente] = useState<any>(null);
  const [saldoClienteMovimentos, setSaldoClienteMovimentos] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [qrCodeData, setQrCodeData] = useState<string | undefined>(undefined);
  const [showExtrato, setShowExtrato] = useState(false);
  const [extratoMovimentos, setExtratoMovimentos] = useState<any[]>([]);
  const [extratoLoading, setExtratoLoading] = useState(false);
  const [extratoTotalRecords, setExtratoTotalRecords] = useState(0);
  const [extratoLazyState, setExtratoLazyState] = useState({
    first: 0,
    rows: 5,
    page: 1,
    cliente: cliente?.id,
    sortField: 'data',
    sortOrder: SortOrder.DESC
  });

  const saveSaldoCliente = async (saldoClienteData: any): Promise<string> => {
    try {
      const response = await postSaldoClienteCompra(saldoClienteData);
      if(response.includes('Erro')) {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao processar compra de saldo. Tente novamente.',
          life: 3000
        });
      }
      else{
        // Mostrar sucesso com QR Code
        toast.current?.show({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Compra de saldo realizada com sucesso! Aguarde a confirmação do pagamento.',
        life: 5000
      });
      
      console.log('Salvando saldo cliente:', saldoClienteData);
      
      // Definir QR Code e mostrar tela de sucesso
      setQrCodeData(response);
      setShowSuccess(true);
      setRefreshList(prev => !prev);
      }
      
      
      return response;
    } catch (error) {
      console.error('Erro ao salvar compra de saldo:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro ao processar compra de saldo. Tente novamente.',
        life: 3000
      });
      throw error;
    }
  };

  const handleNewCompra = () => {
    setShowSuccess(false);
    setQrCodeData(undefined);
    setShowForm(true);
  };

  const handleEdit = (saldoClienteData: any) => {
    setShowSuccess(false);
    setQrCodeData(undefined);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setShowSuccess(false);
    setQrCodeData(undefined);
  };

  const getSaldoAtual = () => {
    return saldo;
  };

  const loadExtrato = (lazyParams: any) => {
    setExtratoLoading(true);
    const params = {
      ...lazyParams,
      cliente: cliente?.id
    };
    findSaldoClienteMovimentoService(params)
      .then(data => {
        setExtratoMovimentos(data.movimentos || []);
        setExtratoTotalRecords(data.total || 0);
      })
      .catch(() => {
        setExtratoMovimentos([]);
        setExtratoTotalRecords(0);
      })
      .finally(() => {
        setExtratoLoading(false);
      });
  };

  const handleOpenExtrato = () => {
    setShowExtrato(true);
    loadExtrato(extratoLazyState);
  };

  const handleExtratoPageChange = (event: any) => {
    const newLazyState = {
      ...extratoLazyState,
      first: event.first,
      rows: event.rows,
      page: event.page + 1
    };
    setExtratoLazyState(newLazyState);
    loadExtrato(newLazyState);
  };

  const formatarDataMovimento = (data: string) => {
    const dataMovimento = new Date(data);
    const hoje = new Date();
    const ontem = new Date();
    ontem.setDate(ontem.getDate() - 1);
    
    const dataMovimentoDia = new Date(dataMovimento.getFullYear(), dataMovimento.getMonth(), dataMovimento.getDate());
    const hojeDia = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
    const ontemDia = new Date(ontem.getFullYear(), ontem.getMonth(), ontem.getDate());
    
    let prefixoData = '';
    if (dataMovimentoDia.getTime() === hojeDia.getTime()) {
      prefixoData = 'Hoje';
    } else if (dataMovimentoDia.getTime() === ontemDia.getTime()) {
      prefixoData = 'Ontem';
    } else {
      prefixoData = dataMovimento.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
    
    const hora = dataMovimento.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
    
    return `${prefixoData}, ${hora}`;
  };

  const loadInfo = () => {
    const lazyState ={
        first: 0,
        rows: 10,
        page: 1,
        cliente: cliente?.id,
        sortField: 'data',
        sortOrder: SortOrder.DESC
    };
    findSaldoClienteMovimentoService(lazyState).then(data => {setSaldoClienteMovimentos(data.movimentos)}).catch(() => {setSaldoClienteMovimentos([])});
    getSaldoCliente(cliente?.id)
      .then((data) => {
        setSaldo(data.saldo || 0.0);
      })
      .catch((error) => {
        console.error('Erro ao buscar saldo do cliente:', error);
      });
  };

  useEffect(() => {
    if(state.user.cliente){
      setCliente(state.user.cliente);
    }
    else{
      getClienteService( window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ]).then((data) => {
        setCliente(data);
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadInfo();
    const handleSaldoClienteAtualizar = () => {
      loadInfo();
      setShowSuccess(false);
      setQrCodeData(undefined);
    };
    window.addEventListener('saldoClienteAtualizar', handleSaldoClienteAtualizar);
    return () => {
      window.removeEventListener('saldoClienteAtualizar', handleSaldoClienteAtualizar);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cliente]);

  return (
    <Container>
        <Toast ref={toast} />
        
        {!cliente || !cliente?.nome ? (
          <div className="flex-consulta align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
            <Card className="shadow-2" style={{ maxWidth: '500px' }}>
              <div className="text-center p-4">
                <div className="bg-orange-50 border-circle w-5rem h-5rem flex align-items-center justify-content-center mx-auto mb-4">
                  <i className="pi pi-exclamation-triangle text-4xl text-orange-500"></i>
                </div>
                <h3 className="mt-0 mb-3 text-900">Saldo não encontrado</h3>
                <p className="text-600 mb-4">
                  Não foi possível carregar as informações do saldo do cliente. 
                  Por favor, verifique sua conexão e tente novamente.
                </p>
                <Button
                  label="Tentar Novamente"
                  icon="pi pi-refresh"
                  onClick={() => window.location.reload()}
                  style={{ backgroundColor: '#183462', border: 'none' }}
                />
              </div>
            </Card>
          </div>
        ) : (
        <div>
        
        {/* Header */}
        <div className="mb-4">
            <HeaderTitle icon="pi-shopping-cart" title={`Meus créditos - ${cliente?.nome || ''}`} />
        </div>

        {/* Dashboard Section */}
        <div className="grid mb-4">
            {/* Card com Saldo Atual */}
            <div className="col-12 md:col-6">
                <Card className="shadow-2" >
                    <div  className="text-center p-4 h-full flex-consulta flex-column justify-content-between">
                    <div style={{height: '370px'}}>
                        <div className="bg-blue-50 border-circle w-4rem h-4rem flex-consulta align-items-center justify-content-center mx-auto mb-3">
                        <i className="pi pi-wallet text-3xl text-blue-500"></i>
                        </div>
                        <h4 className="mt-0 mb-2 text-900">Saldo Atual</h4>
                        <div className="text-2xl font-bold text-green-600 mb-4">
                        {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        }).format(getSaldoAtual())}
                        </div>
                    </div>
                    <Button
                        label="Nova Compra"
                        icon="pi pi-plus"
                        className="w-full p-button-lg"
                        style={{ backgroundColor: '#183462', border: 'none' }}
                        onClick={handleNewCompra}
                    />
                    </div>
                </Card>
            </div>

            {/* Card com Extrato - Últimas Movimentações */}
            <div className="col-12 md:col-6">
                <Card className="shadow-2">
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '1.5rem' }}>
                    <div className="flex-consulta align-items-center gap-2 mb-4">
                        <div className="bg-orange-50 border-circle w-3rem h-3rem flex-consulta align-items-center justify-content-center">
                        <i className="pi pi-history text-xl text-orange-500"></i>
                        </div>
                        <h4 className="m-0 text-900">Últimas Movimentações</h4>
                    </div>
                    
                    <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <div style={{ flex: 1, overflowY: 'auto', paddingRight: '8px' }}>
                        <div className="flex-consulta flex-column gap-3" style={{height: '300px'}} >
                            {saldoClienteMovimentos.length > 0 ? (
                              saldoClienteMovimentos.map((movimento: any, index: number) => {
                                const isEntrada = movimento.tipoMovimento === 'ENTRADA';
                                const dataMovimento = new Date(movimento.data);
                                const hoje = new Date();
                                const ontem = new Date();
                                ontem.setDate(ontem.getDate() - 1);
                                
                                // Zerar as horas para comparação apenas de dia
                                const dataMovimentoDia = new Date(dataMovimento.getFullYear(), dataMovimento.getMonth(), dataMovimento.getDate());
                                const hojeDia = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
                                const ontemDia = new Date(ontem.getFullYear(), ontem.getMonth(), ontem.getDate());
                                
                                let prefixoData = '';
                                if (dataMovimentoDia.getTime() === hojeDia.getTime()) {
                                  prefixoData = 'Hoje';
                                } else if (dataMovimentoDia.getTime() === ontemDia.getTime()) {
                                  prefixoData = 'Ontem';
                                } else {
                                  prefixoData = dataMovimento.toLocaleDateString('pt-BR', {
                                    day: '2-digit',
                                    month: '2-digit'
                                  });
                                }
                                
                                const hora = dataMovimento.toLocaleTimeString('pt-BR', {
                                  hour: '2-digit',
                                  minute: '2-digit'
                                });
                                
                                const dataFormatada = `${prefixoData}, ${hora}`;
                                
                                return (
                                  <div key={index} className="flex-consulta align-items-center justify-content-between p-3 border-round surface-100">
                                    <div className="flex-consulta align-items-center gap-2">
                                      <i className={`pi ${isEntrada ? 'pi-plus-circle text-green-500' : 'pi-minus-circle text-red-500'}`}></i>
                                      <div>
                                        <div className="font-semibold text-900">{movimento.produto}</div>
                                        <small className="text-600">{dataFormatada + ' - ' + movimento.usuario}</small>
                                      </div>
                                    </div>
                                    <div className={`font-bold ${isEntrada ? 'text-green-600' : 'text-red-600'}`}>
                                      {isEntrada ? '+' : '-'}
                                      {new Intl.NumberFormat('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                      }).format(Math.abs(movimento.valor))}
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="text-center p-4 text-600">
                                <i className="pi pi-inbox text-4xl mb-3" style={{ display: 'block' }}></i>
                                <p>Nenhuma movimentação encontrada</p>
                              </div>
                            )}
                        </div>
                        </div>
                    </div>
                    
                    <div className="text-center" style={{ marginTop: '12px', flexShrink: 0 }}>
                        <Button
                        label="Ver Extrato Completo"
                        icon="pi pi-external-link"
                        style={{ color: '#183462' }}
                        outlined
                        size="small"
                        className="p-button-sm"
                        onClick={handleOpenExtrato}
                        />
                    </div>
                    </div>
                </Card>
            </div>
        </div>

        {/* Cards Informativos */}
        <div className="grid mb-4">
            <div className="col-12">
            <div className="grid h-full">
                <div className="col-12 lg:col-4">
                <Card className="h-full text-center shadow-1 border-1 surface-border">
                    <div className="p-3">
                    <div className="bg-blue-50 border-circle w-3rem h-3rem flex-consulta align-items-center justify-content-center mx-auto mb-3">
                        <i className="pi pi-credit-card text-2xl text-blue-500"></i>
                    </div>
                    <h6 className="mt-0 mb-2 text-900">Múltiplas Formas</h6>
                    <p className="m-0 text-sm text-600">Cartão, PIX, boleto ou faturamento</p>
                    </div>
                </Card>
                </div>
                <div className="col-12 lg:col-4">
                <Card className="h-full text-center shadow-1 border-1 surface-border">
                    <div className="p-3">
                    <div className="bg-green-50 border-circle w-3rem h-3rem flex-consulta align-items-center justify-content-center mx-auto mb-3">
                        <i className="pi pi-shield text-2xl text-green-500"></i>
                    </div>
                    <h6 className="mt-0 mb-2 text-900">Seguro</h6>
                    <p className="m-0 text-sm text-600">Transações criptografadas e protegidas</p>
                    </div>
                </Card>
                </div>
                <div className="col-12 lg:col-4">
                <Card className="h-full text-center shadow-1 border-1 surface-border">
                    <div className="p-3">
                    <div className="bg-orange-50 border-circle w-3rem h-3rem flex-consulta align-items-center justify-content-center mx-auto mb-3">
                        <i className="pi pi-clock text-2xl text-orange-500"></i>
                    </div>
                    <h6 className="mt-0 mb-2 text-900">Rápido</h6>
                    <p className="m-0 text-sm text-600">Crédito em até 2 horas úteis</p>
                    </div>
                </Card>
                </div>
            </div>
            </div>
        </div>

        {/* Lista ou Formulário */}
        <div className="w-full">
          <SaldoClienteList 
            onEdit={handleEdit}
            refresh={refreshList}
            cliente={cliente?.id}
            onRefresh={loadInfo}
          />
        </div>

        {/* Modal de Cadastro */}
        <Dialog
          visible={showForm}
          onHide={handleClose}
          style={{ width: showSuccess ? '450px' : '50vw' }}
          breakpoints={{ '960px': '75vw', '641px': '95vw' }}
          modal
          dismissableMask={!showSuccess}
        >
          <SaldoClienteCadastrar 
            onSave={saveSaldoCliente} 
            onClose={handleClose}
            showSuccess={showSuccess}
            qrCodeData={qrCodeData}
          />
        </Dialog>

        {/* Modal de Extrato Completo */}
        <Dialog
          visible={showExtrato}
          onHide={() => setShowExtrato(false)}
          header={
            <div className="flex-consulta align-items-center gap-2">
              <div className="bg-orange-50 border-circle w-3rem h-3rem flex-consulta align-items-center justify-content-center">
                <i className="pi pi-history text-xl text-orange-500"></i>
              </div>
              <span className="text-900 font-semibold text-xl">Extrato Completo</span>
            </div>
          }
          style={{ width: '60vw' }}
          breakpoints={{ '960px': '80vw', '641px': '95vw' }}
          modal
          dismissableMask
        >
          <div style={{ minHeight: '400px' }}>
            {extratoLoading ? (
              <div className="flex align-items-center justify-content-center" style={{ height: '300px' }}>
                <i className="pi pi-spin pi-spinner text-4xl text-primary"></i>
              </div>
            ) : extratoMovimentos.length > 0 ? (
              <div className="flex-consulta flex-column gap-3">
                {extratoMovimentos.map((movimento: any, index: number) => {
                  const isEntrada = movimento.tipoMovimento === 'ENTRADA';
                  return (
                    <div key={index} className="flex-consulta align-items-center justify-content-between p-3 border-round surface-100">
                      <div className="flex-consulta align-items-center gap-2">
                        <i className={`pi ${isEntrada ? 'pi-plus-circle text-green-500' : 'pi-minus-circle text-red-500'}`}></i>
                        <div>
                          <div className="font-semibold text-900">{movimento.produto}</div>
                          <small className="text-600">{formatarDataMovimento(movimento.data)} - {movimento.usuario}</small>
                        </div>
                      </div>
                      <div className={`font-bold ${isEntrada ? 'text-green-600' : 'text-red-600'}`}>
                        {isEntrada ? '+' : '-'}
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        }).format(Math.abs(movimento.valor))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center p-4 text-600" style={{ height: '300px' }}>
                <i className="pi pi-inbox text-4xl mb-3" style={{ display: 'block' }}></i>
                <p>Nenhuma movimentação encontrada</p>
              </div>
            )}
            
            {extratoTotalRecords > 0 && (
              <div className="mt-4">
                <Paginator
                  first={extratoLazyState.first}
                  rows={extratoLazyState.rows}
                  totalRecords={extratoTotalRecords}
                  onPageChange={handleExtratoPageChange}
                />
              </div>
            )}
          </div>
        </Dialog>
        </div>
        )}
    </Container>
  );
}